<template>
    <Modal
        :visible="props.visible"
        class="no-data-modal"
        @cancel="props.onClose"
        width="1200px"
    >
        <img :src="NoDataImage" alt="no-data"/>
        <h2 class="no-data-modal__title">Не найден в базе. Вы хотите создать?</h2>
        <button class="no-data-modal__button" @click="handleCreateContragent">
            Создать резидента
        </button>

        <template #footer/>
    </Modal>
</template>

<script setup>
import { Modal } from 'ant-design-vue';
import NoDataImage from "../../assets/no-data.svg";
import { useRouter } from 'vue-router';

const router = useRouter();

const props = defineProps({
    onClose: {
        type: Function,
        required: true
    },
    visible: {
        type: Boolean,
        required: true
    },
    // Задан — создаём резидента на месте (форма в модалке), иначе уходим на отдельную страницу.
    onCreate: {
        type: Function,
        default: null
    }
});

const handleCreateContragent = () => {
    if (props.onCreate) {
        props.onCreate();
        return;
    }

    router.push("/create-contragent");
};

</script>

<style>
.no-data-modal {
    .ant-modal-footer {
        display: none;
    }

    .ant-modal-content {
        width: 1200px;
    }

    .ant-modal-body {
        width: 100%;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
}

.no-data-modal__title {
    font-size: 24px;
    font-weight: 500;
    color: #373737;
    text-align: center;

    margin: 0;
}

.no-data-modal__button {
    width: 500px;
    background-color: #007BFF;
    color: white;

    padding: 12px 0;

    border-radius: 8px;

    border: none;
    cursor: pointer;

    margin-top: 20px;

    &:hover {
        background-image: linear-gradient(to right, #F5010A 0%, #1521E9 100%)
    }
}
</style>